import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { inject, Injectable, NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { AclDirective, AclResourceDirective } from './acl/acl-resource.directive';
import { AsyncItemComponent, FormattedDataValueComponent } from './async-item/async-item.component';
import { DatasourceCredentialsModalComponent } from './datasource-credentials-modal/datasouce-credentials-modal.component';
import { DateModule } from './date';
import { FeatureSheetLinkComponent } from './feature-sheet/link.component';
import { FileDropDirective } from './file-drop/file-drop.directive';
import { ImageInputComponent } from './file-drop/image-input.components';
import { ImageUploadComponent } from './file-drop/image-upload.component';
import { FileResizeModalComponent } from './file-resize-modal/file-resize-modal.component';
import { AutocompleteOffFormDirective, AutocompleteOffInputDirective } from './form-utils/autocomplete-off.directive';
import { AutofocusDirective } from './form-utils/autofocus.directive';
import { CheckboxCheckedDirective } from './form-utils/checkbox-checked.directive';
import { FormAttributeDirective } from './form-utils/form-attribute.directive';
import { FormDirective, IsInvalidContainerDirective, IsInvalidControlDirective } from './form-utils/is-invalid.directive';
import { LabelForDirective } from './form-utils/label-for.directive';
import { NumberDirective } from './form-utils/number.validator';
import { PlaceholderDirective } from './form-utils/placeholder.directive';
import { GoogleModule } from './google';
import { IframeDirective } from './iframe/iframe.directive';
import { InputSliderComponent } from './input-slider.component';
import { LoadingAccountComponent } from './loading-account/loading-account.component';
import { LoadingBarModule } from './loading-bar';
import { LogEventDirective } from './log-event/log-event.directive';
import { LogoSmComponent } from './logo/logo-sm.component';
import { LogoComponent } from './logo/logo.component';
import { PidFormatPipe } from './pid-format/pid-format.pipe';
import { PipesModule } from './pipes';
import { QrCodeComponent } from './qr-code';
import { CoverImageComponent } from './report-cover/cover-image.component';
import { CoverPreviewComponent } from './report-cover/cover-preview.component';
import { ShareDialogComponent } from './share-dialog/share-dialog.component';
import { AveragePipe } from './table/average.pipe';
import { ComparablesContainerComponent } from './table/comparables-container.component';
import { ComparablesTableComponent } from './table/comparables-table.component';
import { CustomizeColumnsModalComponent } from './table/customize-columns-modal.component';
import { OptionGroupComponent, OptionsLayoutComponent } from './table/options-group.component';
import { ScrollableDirective } from './table/scrollable.directive';
import { StickyElementDirective, StickyTargetDirective } from './table/sticky.directive';
import { TableHeaderComponent } from './table/table-header.component';
import { UiModule } from './ui';
import { WelcomeLayoutComponent } from './welcome-layout/welcome-layout.component';


@Injectable()
export class CustomTitleStrategy extends TitleStrategy {

    private title = inject(Title);

    buildTitle(state: RouterStateSnapshot) {
        const titles: string[] = [];
        let node: ActivatedRouteSnapshot | null = state.root;
        while (node != null) {
            if (node.title) {
                titles.push(node.title);
            }
            node = node.firstChild;
        }
        return titles.join(' > ');
    }

    updateTitle(state: RouterStateSnapshot) {
        const title = this.buildTitle(state);
        this.title.setTitle('AUTOPROP ' + title);
    }
}


const MODULES = [
    AclResourceDirective,
    AclDirective,
    AsyncItemComponent,
    FormattedDataValueComponent,
    DatasourceCredentialsModalComponent,
    DateModule,
    FeatureSheetLinkComponent,
    FileDropDirective,
    ImageUploadComponent,
    ImageInputComponent,
    FileResizeModalComponent,
    AutocompleteOffFormDirective,
    AutocompleteOffInputDirective,
    AutofocusDirective,
    CheckboxCheckedDirective,
    FormAttributeDirective,
    FormDirective,
    IsInvalidContainerDirective,
    IsInvalidControlDirective,
    LabelForDirective,
    NumberDirective,
    PlaceholderDirective,
    GoogleModule,
    IframeDirective,
    InputSliderComponent,
    LoadingAccountComponent,
    LoadingBarModule,
    LogoComponent,
    LogoSmComponent,
    PidFormatPipe,
    PipesModule,
    QrCodeComponent,
    CoverImageComponent,
    CoverPreviewComponent,
    ShareDialogComponent,
    AveragePipe,
    ComparablesContainerComponent,
    ComparablesTableComponent,
    CustomizeColumnsModalComponent,
    OptionGroupComponent,
    OptionsLayoutComponent,
    ScrollableDirective,
    StickyElementDirective,
    StickyTargetDirective,
    TableHeaderComponent,
    UiModule,
    WelcomeLayoutComponent,
    DragDropModule,
    CdkScrollableModule,
    LogEventDirective,
];

@NgModule({
    imports: [
        ...MODULES,
    ],
    exports: [
        ...MODULES,
    ],
})
export class SharedModule {}
